import Container from 'quarks/Container';
import Flex from 'quarks/Flex';
import Text from 'quarks/Text';
import type { BasicProps } from 'quarks/interpolations/basic';

import Modal from 'molecules/Modal/Modal';

import richTextParser from 'utils/richTextParser';

import type { ContentfulComponentCard } from 'graphqlTypes';
import type { FC } from 'react';

interface PopupProps extends BasicProps {
  open: boolean;
  onClose: () => void;
  desc?: ContentfulComponentCard['transcript'];
}

const Popup: FC<PopupProps> = ({ desc, open, onClose, ...props }) => (
  <Modal
    open={open}
    onClose={onClose}
    width="100%"
    maxWidth="730px"
    marginX="auto"
    containerStyles={`
    > div {
      width: 100%;
    }
  `}
  >
    <Container
      position="relative"
      xs={{ paddingY: 0, marginAll: 0, borderRadius: 0, height: '100dvh' }}
      md={{ paddingY: 32, marginY: 32, borderRadius: '8px', height: 'unset' }}
      marginY={32}
      borderRadius="8px"
      backgroundColor="gray-50"
      {...props}
    >
      <Flex
        flexDirection="column"
        paddingAll={24}
        gap="32px"
        width="100%"
        xs={{ height: '100dvh' }}
        md={{ height: 'unset', paddingAll: 40 }}
      >
        <Flex width="100%" flexDirection="column" gap="8px" justifyContent="center" alignItems="center">
          <Text
            textStyle="textMd"
            fontWeight="bold"
            textColor="navy-900"
            lg={{ textStyle: 'textLg', fontWeight: 'bold' }}
          >
            FieldRoutes Testimonial Transcript
          </Text>
        </Flex>
        {desc && (
          <Flex
            width="100%"
            maxHeight="400px"
            height="100%"
            overflowX="hidden"
            overflowY="auto"
            flexDirection="column"
            gap="16px"
            textColor="gray-900"
            xs={{ maxHeight: 'unset' }}
            md={{ maxHeight: '400px' }}
            lg={{ maxWidth: '80%', marginX: 'auto' }}
          >
            {richTextParser(desc)}
          </Flex>
        )}
      </Flex>
    </Container>
  </Modal>
);

export default Popup;
